/**
 * Delegate clicks from a parent to child links/buttons.
 * Actions param should be some like:
 * {
 *   'modallink': openModal
 * }
 * Where modallink is the class the link/button would have
 * and openModal is a function that will be called with the original event
 * and the link/button element as arguments.
 * @param {Event} ev Click event.
 * @param {Object} actions Class => function.
 */
const delegateClicks = function(ev, actions) {
    // Common click elements and their children.
    const tags = ['A', 'I', 'SPAN', 'B', 'BUTTON', 'STRONG', 'SMALL'];
    const tag = ev.target.tagName;
    // if none of those just stop now
    if (tags.indexOf(tag) === -1) {
        return;
    }

    const actionClasses = Object.keys(actions);
    // Check links first
    const link = ev.target.closest('A');
    if (link) {
        for (const aClass of actionClasses) {
            if (link.classList.contains(aClass)) {
                ev.preventDefault();
                actions[aClass](ev, link);
                return;
            }
        }
    }
    // Then check buttons
    const button = ev.target.closest('button');
    if (button) {
        for (const aClass of actionClasses) {
            if (button.classList.contains(aClass)) {
                ev.preventDefault();
                actions[aClass](ev, button);
                return;
            }
        }
    }
};
